const generateRandomMinusId = () => {
  return -1 * Math.abs(Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000);
};
export default generateRandomMinusId;
